import { createAction } from '@reduxjs/toolkit'
import { IdpInfo } from 'models'

export const setIdpInfo = createAction<IdpInfo>('setNomIdp')
